import axios from 'axios';

export const coinGeckoAxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_COINGECKO_API_BASE_URL,
});

export const shardeumAxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SHARDEUM_API_BASE_URL,
});

coinGeckoAxiosInstance.interceptors.request.use(
  (config) => {
    const key = import.meta.env.VITE_COINGECKO_API_KEY;

    if (key) {
      if (!config.params) config.params = {};
      config.params['x-cg-demo-api-key'] = key;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
